import * as Request from '../../request'
import * as Constants from '../engagement-summary/constants'

export const fetchDomainEngagementSummary = (community: string, timeSpan: string = '') =>
  Request.requestActionCreator(Constants.FETCH_ENGAGEMENT_SUMMARY)
  ({
    method: 'GET',
    url: `${Constants.SERVER_RESOURCE}/${community}?aggregation=domain&timeSpan=${timeSpan}`,
  })

export const defineCommunity = (communityIdentifier: string) =>
  ({type: Constants.DEFINE_COMMUNITY, value: communityIdentifier})



// WEBPACK FOOTER //
// ./src/pages/domain-deliverability/actions.ts